import { ensureRenderableHtml } from './ensureRenderableHtml';

/**
 * When the model returns a single-line email, insert blank lines after the
 * greeting and before the closing so Draft can show a readable layout.
 * Leaves text that already has newlines untouched.
 */
export function injectEmailParagraphBreaks(value: string): string {
    let text = String(value ?? '').replace(/\r\n/g, '\n').replace(/\r/g, '\n').trim();
    if (!text || /[\n]/.test(text))
        return text;

    text = text.replace(
        /^(Bonjour,|Bonsoir,|Hello,|Hi,|Dear\s+[^,]+,|Cher(?:e|es)?\s+[^,]+,|Madame,|Monsieur,)\s+/i,
        '$1\n\n'
    );

    text = text.replace(
        /\s+((?:Bien\s+)?cordialement|Bien\s+à\s+vous|Meilleures\s+salutations|Best\s+regards|Kind\s+regards|Regards|Sincerely)([.!]?\s*)$/i,
        '\n\n$1$2'
    );

    return text;
}

/** Plain-text AI reply → HTML suitable for html-to-draftjs / Draft editor. */
export function formatSuggestedReplyHtml(value: string): string {
    return ensureRenderableHtml(injectEmailParagraphBreaks(value));
}
